
<collapsible-section
    :id="id"
    control-name="elementsCollapse"
    :is-open="isOpen"
>
  <template #section-header>
    Elements
  </template>

  <template #section-contents>
    <slot></slot>
  </template>
</collapsible-section>
